module.exports = __webpack_public_path__ + "img/solution1.62f9bf18.png";